<template>
    <div class="footer-quick">
        <a :href="$cp + 'healing'"><span>힐링은평</span></a>
        <a :href="$cp + 'commercial'"><span>상권분석</span></a>
        <a :href="$cp + 'indicator'"><span>구정현황</span></a>
    </div>
</template>

<script>
import commonConstMixin from "@/store/common.const.mixin.js";

export default {
    name: 'ShortCut',
    mixins: [commonConstMixin],
}
</script>

<style scoped>

</style>
